import loadable from '@loadable/component';
import React from 'react';
import { AppProps, Location } from '../../types';
import { useIntersecting } from '../hooks/useIntersecting';
import { DEFAULT_ZOOM, EVENT_MAP_ID } from '../_shared/constants';

export interface EventMapProps {
    eventName: string;
    venueName: string;
    venueAddress: string;
    location: Location;
    mapZoom: number;
    gMapsApiKey: string;
}

const getEventMapProps = (props: AppProps): EventMapProps => {
    return {
        eventName: props.event.name,
        mapZoom: DEFAULT_ZOOM,
        ...props.components.eventMap,
    };
};

export const LazyEventMap = loadable(() => import('./EventMapMount'));

const EventMapRoot = (props: AppProps) => {
    const eventMapProps = getEventMapProps(props);
    const eventMapContainer = document.getElementById(EVENT_MAP_ID);
    const [isIntersecting] = useIntersecting(eventMapContainer);
    return <>{isIntersecting ? <LazyEventMap {...eventMapProps} /> : null}</>;
};

export default EventMapRoot;
